import * as React from "react";
const SvgFiRrDolphin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dolphin_svg__a)">
      <path
        fill="#062147"
        d="M21.938 7c-.448-3.623-3.327-7-8.438-7-2.004 0-4.134.486-6.01 1.607C5.991.907 3.951.248 1.313.004.394-.08-.45 1.127.273 1.7a13.45 13.45 0 0 1 3.38 3.935C2.626 7.524 2 9.948 2 13c0 2.43.61 4.695 1.075 6.066-1.49.723-2.647 2.076-3.045 3.677-.169.68.397 1.35 1.09 1.246 3.191-.477 4.38-2.737 4.38-2.737s1.227 2.256 4.38 2.737c.693.106 1.26-.565 1.09-1.245-.43-1.726-1.74-3.164-3.4-3.835.205-1.705.858-3.543 1.753-4.84.79-1.146 1.814-1.882 2.897-2.345.373.565.764 1.455 1.064 2.862.138.646 1.181.486 1.418-.13.553-1.44.83-2.574.952-3.447C15.806 11.003 22 11 22 11c1.103 0 2-.897 2-2s-.958-2-2.062-2m-5.837 2c-3.737 0-6.65 1.36-8.424 3.933-1.052 1.525-1.807 3.592-2.072 5.571-.035 0-.435.007-.598.022-.417-1.215-1.006-3.32-1.006-5.525 0-10.47 7.913-11 9.5-11C17.965 2 20 5.11 20 8a1 1 0 0 0 1 1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dolphin_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDolphin;
